import React, { useState, useContext, useEffect } from 'react';
import { Button, Col, Form, Input, Modal, Row, Select, Card, Table , Checkbox} from 'antd';
import Colors from "../../../styles/Colors";
import { BiCheck, BiX } from "react-icons/bi";
import { AuthContext } from "../../../config/AuthContext";
import { Rol ,defaultRol} from '../../../model/root/Rol';
import {GetUsuaris} from "../../../dao/root/GetUsuaris";
import { PostRolDuplicar } from '../../../dao/admin/PostRolDuplicar';
import {ColumnsType} from "antd/es/table";
import { Pagina, defaultPagina} from '../../../model/root/Pagina';
import {PutPaginaRol} from "../../../dao/root/PutPaginaRol";
import {GetEmpresas} from '../../../dao/admin/GetEmpresas';


const { Option } = Select;

interface DuplicarRolModalProps {
    element: Rol;
    visible: boolean;
    onClose: (value: boolean) => void;
}


const DuplicarRolModal: React.FC<DuplicarRolModalProps> = ({ element, visible, onClose }) => {
    const [form] = Form.useForm();
    const { isLoggedIn, userId, user, page } = useContext(AuthContext);
    const [pagines, setPagines] =  useState<any[]>([]);
    const [empresas, setDadesEmpresa] = useState<any[]>([]);
    const [rol, setRol] =  useState<Rol[]>([]);
    const [permisosSeleccionats, setPermisosSeleccionats] = useState<Pagina[]>([]);


    useEffect(() => {
        if (visible) {
            checkDades();
        }
       }, [visible]);
   
    async function checkDades() {
        // Obtener empresas
        try {
            const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
            setDadesEmpresa(dadesEmpresas || []);
        } catch (error) {
            console.error("Error:", error);
            setDadesEmpresa([])
        }
    }
    const handleEmpresaChange = async (empresa: string) => {
        form.setFieldValue("empresa", empresa);
        // Cargar paginas
        const dades = await GetUsuaris(empresa);
        setPagines(dades?.pagines || []);
        
    };
    const handleSubmit = async () => {
        
        const empresaSeleccionada = form.getFieldValue('empresa');
        
        const nouRol: Rol = {
        ...element, 
        pagines: permisosSeleccionats, 
        };
        await PostRolDuplicar(nouRol, empresaSeleccionada);
        onClose(true);
    };

    const togglePermis = (id_pagina: number, tipus: boolean) => {
    setPermisosSeleccionats((prev) => {
        const existe = prev.find((p) => p.id === id_pagina && (p as any).tipus === tipus);
        if (existe) {
        return prev.filter((p) => !(p.id === id_pagina && (p as any).tipus === tipus));
        } else {
        const pagina = pagines.find((p) => p.id === id_pagina);
        if (!pagina) return prev;
        return [...prev, { ...pagina, tipus }];
        }
    });
    };



    const handleCancel = () => {
        onClose(false);
    };
    const columns: ColumnsType<Pagina> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
        },
        {
            key: 'accions', title: 'Visualitzar', dataIndex: 'accions', width: 30,
            render: (estat, el) => (
                <>
                    <Checkbox 
                        disabled={el.nom === 'pantalles' || el.nom === 'bundles' }
                        onClick={() => togglePermis(el.id, false)} />
                </>
            ),
        },
        {
            key: 'accions', title: 'Modificar', dataIndex: 'accions', width: 30,
            render: (estat, el) => (
                <>
                    <Checkbox 
                        disabled={el.nom === 'pantalles' || el.nom === 'bundles' }
                        onClick={() => togglePermis(el.id, true)}/>
                </>
            ),
        },
    ];

    return (
        <Modal
            title="Duplicar Rol"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={'40%'}
        >
            <Form form={form} layout="vertical" onFinish={handleSubmit} >
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item 
                            label={
                                <span>
                                    Escull l'empresa on vols duplicar el rol <strong>{element.nom}</strong>
                                </span>
                            }
                            name="empresa" 
                            rules={[{ required: true, message: 'Introdueix l\'empresa' }]}
                        >
                            <Select
                                placeholder="Selecciona una empresa"
                                onChange={handleEmpresaChange}
                            >
                                {Array.isArray(empresas) && empresas.map(value =>
                                    <Option key={value.id} value={value.datasource}>
                                        {value.nomEmpresa}
                                    </Option>
                                )}
                            </Select>
                                                                                           
                        </Form.Item>
                    </Col>
                    {form.getFieldValue("empresa") && (
                        <>
                        
            
                    <Col style={{marginLeft:'20px', marginRight:'20px'}}>
                        <Card title="Assignar permisos a les pàgines" size="small">
                            <Table tableLayout={"fixed"}
                                size={"small"}
                                columns={columns}
                                dataSource={pagines}
                            />
                        </Card>
                    </Col>
                    </>
                    )}
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default DuplicarRolModal;